const constants = require('@/util/constants')
require('./config')

/**
 * 调用http-rest-api发送消息
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function sendMessageRest(json, successcb, failedcb) {
  axios.post('/api/messages/send', {
    json,
    client: constants.HTTP_CLIENT
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 加载聊天记录
 * @param {*} accessToken token
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function getMessages (uid, page, size, successcb, failedcb) {
  axios.get('/api/messages/user', {
    params: {
      'uid': uid,
      'page': page,
      'size': size,
      'client': constants.HTTP_CLIENT
    }
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 根据topic加载聊天记录
 * @param {*} accessToken token
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function getMessagesByTopic(topic, page, size, successcb, failedcb) {
  axios.get('/api/messages/topic', {
    params: {
      'topic': topic,
      'page': page,
      'size': size,
      'client': constants.HTTP_CLIENT
    }
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 查询当前用户-某技能组wid或指定客服未读消息数目
 * 注意：技能组wid或指定客服唯一id
 * 适用于 访客 和 客服
 */
export function getUreadCount(wid, successcb, failedcb) {
  axios.get('/api/messages/unreadCount', {
    params: {
      'wid': wid,
      'client': constants.HTTP_CLIENT
    }
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 访客端-查询访客所有未读消息数目
 */
export function getUreadCountVisitor(successcb, failedcb) {
  axios.get('/api/messages/unreadCount/visitor', {
    params: {
      'client': constants.HTTP_CLIENT
    }
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 客服端-查询客服所有未读消息数目
 */
export function getUreadCountAgent(successcb, failedcb) {
  axios.get('/api/messages/unreadCount/agent', {
    params: {
      'wid': wid,
      'client': constants.HTTP_CLIENT
    }
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 查询当前用户-某技能组wid或指定客服未读消息数目
 * 注意：技能组wid或指定客服唯一id
 * 适用于 访客 和 客服
 */
export function getUreadMessage(wid, page, size, successcb, failedcb) {
  axios.get('/api/messages/unread/message', {
    params: {
      'wid': wid,
      'page': page,
      'size': size,
      'client': constants.HTTP_CLIENT
    }
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 访客端-查询访客所有未读消息
 */
export function getUnreadMessagesVisitor(page, size, successcb, failedcb) {
  axios.get('/api/messages/unread/message/visitor', {
    params: {
      'page': page,
      'size': size,
      'client': constants.HTTP_CLIENT
    }
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 客服端-查询客服所有未读消息
 */
export function getUnreadMessagesAgent(page, size, successcb, failedcb) {
  axios.get('/api/messages/unread/message/agent', {
    params: {
      'page': page,
      'size': size,
      'client': constants.HTTP_CLIENT
    }
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 客服端从聊天记录中分页加载某个用户的商品消息
 * @param {*} accessToken token
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function getMessagesCommodity(uid, page, size, successcb, failedcb) {
  axios.get('/api/messages/commodity', {
    params: {
      'uid': uid,
      'page': page,
      'size': size,
      'client': constants.HTTP_CLIENT
    }
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 加载聊天记录
 * 根据会话Thread加载聊天记录
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function getThreadMessages (tid, page, size, successcb, failedcb) {
  axios.get('/api/messages/thread', {
    params: {
      'tid': tid,
      'page': page,
      'size': size,
      'client': constants.HTTP_CLIENT
    }
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

export function getContactMessages (cid, page, size, successcb, failedcb) {
  axios.get('/api/messages/contact', {
    params: {
      'cid': cid,
      'page': page,
      'size': size,
      'client': constants.HTTP_CLIENT
    }
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

export function getGroupMessages (gid, page, size, successcb, failedcb) {
  axios.get('/api/messages/group', {
    params: {
      'gid': gid,
      'page': page,
      'size': size,
      'client': constants.HTTP_CLIENT
    }
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

export function getChannelMessages(cid, page, size, successcb, failedcb) {
  axios.get('/api/messages/channel', {
    params: {
      'cid': cid,
      'page': page,
      'size': size,
      'client': constants.HTTP_CLIENT
    }
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 历史记录：消息
 * @param {*} page 页面
 * @param {*} size 条数
 */
export function getHistoryMessages (page, size, successcb, failedcb) {
  axios.get('/api/messages/request', {
    params: {
      'page': page,
      'size': size,
      'client': constants.HTTP_CLIENT
    }
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 搜索过滤历史消息
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function searchMessageArchive(page, size, content, type, subDomain, successcb, failedcb) {
  axios.get('/api/messagearchive/filter', {
    params: {
      'page': page,
      'size': size,
      'content': content,
      'type': type,
      'subDomain': subDomain
    }
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 搜索过滤历史消息
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function filterMessage (page, size, nickname, createdAtStart, createdAtEnd,
  workGroupNickname, agentRealName, client, successcb, failedcb) {
  axios.get('/api/messages/filter', {
    params: {
      'page': page,
      'size': size,
      'nickname': nickname,
      'createdAtStart': createdAtStart,
      'createdAtEnd': createdAtEnd,
      'workGroupNickname': workGroupNickname,
      'agentRealName': agentRealName,
      'client': client
    }
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

// /**
//  * 同步发送消息
//  * @param {*} successcb 成功回调
//  * @param {*} failedcb 失败回调
//  */
// export function sendMessageSync (tid, type, content,
//   localId, sessionType, successcb, failedcb) {
//   axios.post('/api/messages/send', {
//     tid: tid,
//     type: type,
//     content: content,
//     status: constants.MESSAGE_STATUS_SENDING,
//     localId: localId,
//     sessionType: sessionType,
//     client: constants.HTTP_CLIENT
//   }).then(response => {
//     successcb(response.data)
//   }).catch(error => {
//     failedcb(error)
//   })
// }
